import { render, staticRenderFns } from "./ReviewPageManage.vue?vue&type=template&id=6e370fea&scoped=true"
import script from "./ReviewPageManage.vue?vue&type=script&lang=js"
export * from "./ReviewPageManage.vue?vue&type=script&lang=js"
import style0 from "./ReviewPageManage.vue?vue&type=style&index=0&id=6e370fea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e370fea",
  null
  
)

export default component.exports